import { jsx as _jsx } from "react/jsx-runtime";
import { formatInternational, getCountryCodeFromPhoneNumber, } from 'lib-shared-phone-numbers';
import { useCallback, useEffect, useMemo } from 'react';
import FlagSelect from 'components/settings/components/sections/telephony/flagSelect';
import { withPhoneNumbers } from 'hocs';
function NumberSelect({ phoneNumbers, selectedNumber, onSelect, disabled, }) {
    const { getItems, getItemsAsyncStatus, hasNextPage, items, nextPage, paramsChange, } = phoneNumbers;
    const isLoading = getItemsAsyncStatus === 'loading';
    const handleOnSelect = useCallback(({ id }) => {
        onSelect(id);
    }, [onSelect]);
    const handleSearch = useCallback((query) => {
        paramsChange({ search: query });
    }, [paramsChange]);
    const options = useMemo(() => items.map(({ e164_format, name }) => {
        var _a;
        const flag = (_a = getCountryCodeFromPhoneNumber(e164_format)) !== null && _a !== void 0 ? _a : '';
        const number = formatInternational(e164_format);
        return {
            id: e164_format,
            flag,
            name: `${number} ${name ? `(${name})` : ''}`,
        };
    }), [items]);
    useEffect(() => {
        getItems();
    }, [getItems]);
    return (_jsx(FlagSelect, { disabled: disabled, isLoading: isLoading && !items.length, items: options, onSelect: handleOnSelect, pagination: {
            infinite: true,
            nextEnable: !!hasNextPage,
            previousEnable: false,
            onNext: nextPage,
        }, placeholder: "Search for e.g. Support or a phone number", selectedItem: selectedNumber, onSearch: handleSearch }));
}
export default withPhoneNumbers(NumberSelect, {
    infinite: true,
});
